import React from 'react';
import PropTypes from 'prop-types';
import TUBE from '@common/images/mc_tube.svg';
import ROTOR from '@common/images/mc_rotor.svg';
import TUBE_ROTOR from '@common/images/mc_tube_rotor.svg';
import {Image} from '@learningblocks/shared-components/lib/Image';

export function Slot(props) {
  const className = `${props.className} ${props.className}_pos--${props.position}`;
  const renderContent = () => {
    if (props.solution && props.rotor) return <Image src={TUBE_ROTOR} alt="" />;
    else if (props.solution) return <Image src={TUBE} alt="" />;
    else if (props.rotor) return <Image src={ROTOR} alt="" />;
    else return null;
  };
  return <div className={className}>{renderContent()}</div>;
}

Slot.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * specifies if solution is present in slot
   */
  solution: PropTypes.bool,
  /**
   * specifies if rotor is present in slot
   */
  rotor: PropTypes.bool,
  /**
   * position id of slot
   */
  position: PropTypes.number,
};

Slot.defaultProp = {
  className: '',
};
